import React, { useRef, useEffect, useMemo } from 'react'
import _get from 'lodash/get'

import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import PagProjectCard from './project-card'

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  gridItem: {
    margin: '24px',
  },
}))

/**
 * Project cards + infinite scroll only. Kept outside connectStateResults loading overlay
 * so Algolia "searching" does not cover the filter drawer (portal) or toolbar.
 */
const ProjectsHitsGrid = (props: any) => {
  const {
    detailViewProject,
    handleViewProject,
    disableProjectView,
    hits,
    hasMore,
    refineNext,
    searching,
    searchPage,
    nbPages,
  } = props

  const classes = useStyles()
  const sentinel: any = useRef(null)

  const onSentinelIntersection = (entries: any) => {
    entries.forEach((entry: any) => {
      const page = searchPage || 0
      if (!searching && page < nbPages && entry.isIntersecting && hasMore) {
        refineNext()
      }
    })
  }

  const observer = new IntersectionObserver(onSentinelIntersection)

  useEffect(() => {
    if (sentinel && sentinel.current) {
      observer.observe(sentinel.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [hits])

  const grid = useMemo(
    () => (
      <>
        {nbPages && _get(hits, [0, 'projectName']) ? (
          <Grid container className={classes.root}>
            {hits.map((project: any) => (
              <Grid key={project.objectID} item className={classes.gridItem}>
                <PagProjectCard
                  project={project}
                  handleViewProject={handleViewProject}
                  disabled={detailViewProject && detailViewProject !== project}
                  disableProjectView={disableProjectView}
                />
              </Grid>
            ))}
            <div tabIndex={-1} ref={sentinel} className="pag-infinite-sentinel" />
          </Grid>
        ) : (
          <>
            {!searching && (
              <div className="pag-flex" style={{ height: '100%' }}>
                <Typography variant="h5">No Projects</Typography>
              </div>
            )}
          </>
        )}
      </>
    ),
    [nbPages, hits, searching, detailViewProject, disableProjectView, handleViewProject]
  )

  return grid
}

export default ProjectsHitsGrid
